import { Tag, Typography } from '@duxton-web/ui';
import { cpGetVerticals } from 'omega-rtc/actions/ucd';
import React from 'react';

import { localeSorter, verticalFromApi } from './adapters';
import EntityListPage, { useEntityList } from './EntityListPage';

const columns = [
  {
    title: 'Vertical',
    dataIndex: 'name',
    width: '40%',
    sorter: localeSorter('name', 'id'),
    render: (_v, r) => <Typography.Body level={2}>{r.name || r.id}</Typography.Body>,
  },
  {
    title: 'Code',
    dataIndex: 'id',
    render: (id) => <Tag>{id}</Tag>,
  },
];

const VerticalsPage = () => {
  const { data, loading } = useEntityList(
    cpGetVerticals, 'ucd.cpVerticals', 'requests.cpGetVerticalsRequest', verticalFromApi,
  );
  const sortedData = React.useMemo(() => [...data].sort(localeSorter('id')), [data]);
  return (
    <EntityListPage
      title="Verticals"
      rowKey="id"
      columns={columns}
      data={sortedData}
      loading={loading}
      emptyText="No verticals onboarded yet."
    />
  );
};

export default VerticalsPage;
